import { PERIOD_COLOR_PALETTE, type PeriodPaletteColor } from './period-colors';

interface PeriodColorPickerProps {
  readonly value: string;
  readonly onChange: (color: PeriodPaletteColor) => void;
}

export function PeriodColorPicker({ value, onChange }: PeriodColorPickerProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-xs font-medium text-[#8b8d9a]">Farge</span>
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Velg farge">
        {PERIOD_COLOR_PALETTE.map((color) => {
          const selected = value.toLowerCase() === color.toLowerCase();
          return (
            <button
              key={color}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={`Farge ${color}`}
              onClick={() => onChange(color)}
              className={`h-7 w-7 rounded-full border-2 transition-transform ${selected ? 'scale-110 border-white' : 'border-transparent hover:scale-105'}`}
              style={{ backgroundColor: color }}
            />
          );
        })}
      </div>
    </div>
  );
}
